import Carrer from "./Carrer";
import Navbar from "./Components/Navbar";
import ContactUs from "./ContactUs";
import Cookie from "./Cookie";
import GetApp from "./GetApp";
import { Routes, Route, Navigate } from "react-router-dom";
import Terms from "./Terms";
import Privacy from "./Privacy";
import Services from "./Services";
import Footer from "./Components/Footer";
import Home from "./Home";
import About from "./About";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./Components/AdminDashboard/AdminDashboard";
import AdminService from "./AdminService";
import AdminServiceCombo from "./AdminServiceCombo";
import AdminBookings from "./Components/AdminBookings/AdminBookings";
import Banners from "./Components/AdminBanner/Banners";
import CodeManagement from "./CodeManagement";
import UserManagement from "./Components/UserManagement/UserManagement";
import SubCategoryTable from "./Components/sub-category/SubCategoryTable";
import AddSubCategory from "./Components/sub-category/AddSubCategory";
import InventoryTable from "./Components/inventory/InventoryTable";
import AddInventory from "./Components/inventory/AddInventory";
import UserDashboard from "./UserDashboard";
import EmployeeDashboard from "./Components/UserManagement/EmployeeDashboard/EmployeeDashboard";
import CategoryTable from "./Components/category/CategoryTable";
import PrerequisiteChecklistTable from "./Components/prerequisiteChecklist/PrerequisiteChecklistTable";
import AddCategory from "./Components/category/AddCategory";
import CreateBooking from "./Components/AdminBookings/CreateBooking/CreateBooking";
import AdminPayments from "./Components/AdminPayments/AdminPayments";
import DealerLedger from "./Components/AdminPayments/DealerLedger";
import RazorpayPayments from "./Components/AdminRazorpay/RazorpayPayments";
import CancellationPolicy from "./Components/CancellationPolicy/CancellationPolicy";
import HomeBuilder from "./Components/AdminHomeBuilder/HomeBuilder";
import ServicePages from "./Components/AdminServicePages/ServicePages";
import PackageBuilders from "./Components/AdminPackageBuilder/PackageBuilders";
import InventoryCategoryTable from "./Components/inventory/inventoryCategoryTable";
import AddInventoryCategory from "./Components/inventory/AddInventoryCategory";
import AdminRBAC from "./Components/rbac/AdminRBAC";
import RequirePermission from "./Components/common/require-permission";
import Forbidden from "./pages/Forbidden";
import AdminInventoryDashboard from "./Components/AdminInventoryDashboard/AdminInventoryDashboard";
import FilteredBookings from "./Components/AdminBookings/FilteredBookings";
import ServicesDashboard from "./Components/ServicesDashboard/ServicesDashboard";
import OrderFeedbackQuestionTable from "./Components/FeedbackQuestion/OrderFeedbackQuestionTable";
import AddOrderFeedbackQuestion from "./Components/FeedbackQuestion/AddOrderFeedbackQuestion";
import FeedbackDashboard from "./Components/FeedbackDashboard/FeedbackDashboard";
import CustomerFeedback from "./Components/AdminCustomerFeedback/CustomerFeedback";
import EmployeeOpsReport from "./Components/EmployeeOpsReport/EmployeeOpsReport";
import OfficeActivity from "./Components/OfficeActivity/OfficeActivity";
import ProfessionalAppActivity from "./Components/ProfessionalAppActivity/ProfessionalAppActivity";
import BookingChanges from "./Components/BookingChanges/BookingChanges";
import TeamInsights from "./Components/TeamInsights/TeamInsights";
import MoneyWatch from "./Components/MoneyWatch/MoneyWatch";
import DailyBrief from "./Components/DailyBrief/DailyBrief";
import AppUpdates from "./Components/AppUpdates/AppUpdates";
import LostDemand from "./Components/LostDemand/LostDemand";
import DeepLinkPage from "./pages/DeepLinkPage";
import { useLocation } from "react-router-dom";
import LeaveManagement from "./Components/AdminLeaves/LeaveManagement";
import StaffDesk from "./Components/AdminStaffDesk/StaffDesk";
import CampaignManagement from "./Components/AdminCampaigns/CampaignManagement";
import LeadManagement from "./Components/AdminLeads/LeadManagement";
import PayoutDashboard from "./Components/AdminPayouts/PayoutDashboard";
import RewardsManagement from "./Components/AdminRewards/RewardsManagement";
import AdminProductAnalytics from "./Components/ProductAnalytics/AdminProductAnalytics";
import CashInHandReport from "./Components/Reports/CashInHandReport";
import GrowthReports from "./Components/GrowthReports/GrowthReports";

function App() {
  const location = useLocation();

  const isDeepLinkRoute = location.pathname.startsWith("/dl");
  return (
    <div className="App">
      {!isDeepLinkRoute && <Navbar />}

      <Routes>
        <Route path="/dl/*" element={<DeepLinkPage />} />
        <Route exact path="/" element={<Home />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/contact" element={<ContactUs />} />
        <Route exact path="/career" element={<Carrer />} />
        <Route exact path="/getApp" element={<GetApp />} />
        <Route exact path="/cookie" element={<Cookie />} />
        <Route exact path="/privacy" element={<Privacy />} />
        <Route exact path="/delete-account" element={<Terms />} />
        <Route exact path="/terms&conditions" element={<Terms />} />
        <Route exact path="/services" element={<Services />} />
        <Route exact path="/admin/login" element={<AdminLogin />} />
        {/* Used to render the admin dashboard with no login check. Sends to
            the guarded dashboard instead. Only the bare folder URL matches -
            deep-link files like /.well-known/assetlinks.json are static files
            served straight from S3 and never reach the router. */}
        <Route
          exact
          path="/.well-known/"
          element={<Navigate to="/admin/dashboard" replace />}
        />

        <Route
          exact
          path="/admin/dashboard"
          element={
            <RequirePermission permission="dashboard.read">
              <AdminDashboard />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/services-dashboard"
          element={
            <RequirePermission permission="dashboard.read">
              <ServicesDashboard />
            </RequirePermission>
          }
        />

        <Route
          exact
          path="/admin/inventory-dashboard"
          element={
            <RequirePermission permission="dashboard.read">
              <AdminInventoryDashboard />
            </RequirePermission>
          }
        />

        <Route
          path="/admin/rbac"
          element={
            <RequirePermission permission="rbac.read">
              <AdminRBAC />
            </RequirePermission>
          }
        />

        <Route
          exact
          path="/admin/services"
          element={
            <RequirePermission permission="services.read">
              <AdminService />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/service-combos"
          element={
            <RequirePermission permission="services.read">
              <AdminServiceCombo />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/bookings"
          element={
            <RequirePermission permission="bookings.read">
              <AdminBookings />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/filtered-bookings"
          element={
            // <RequirePermission permission="bookings.read">
            <FilteredBookings />
            // </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/payments"
          element={
            <RequirePermission permission="payments.read">
              <AdminPayments />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/payments/dealers"
          element={
            <RequirePermission permission="payments.read">
              <DealerLedger />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/razorpay-payments"
          element={
            <RequirePermission permission="payments.read">
              <RazorpayPayments />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/cancellation-policy"
          element={
            <RequirePermission permission="cancellationPolicy.read">
              <CancellationPolicy />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/create/booking"
          element={
            <RequirePermission permission="bookings.create">
              <CreateBooking />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/user-management"
          element={
            <RequirePermission permission="userManagement.read">
              <UserManagement />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/user-dashboard/:userId"
          element={
            <RequirePermission permission="userDashboard.read">
              <UserDashboard />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/feedback-dashboard"
          element={
            <RequirePermission permission="dashboard.read">
              <FeedbackDashboard />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/customer-feedback"
          element={
            <RequirePermission permission="customerFeedback.read">
              <CustomerFeedback />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/employee-activity"
          element={
            <RequirePermission permission="employeeActivity.read">
              <EmployeeOpsReport />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/team-insights"
          element={
            <RequirePermission permission="employeeActivity.read">
              <TeamInsights />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/professional-app"
          element={
            <RequirePermission permission="employeeActivity.read">
              <ProfessionalAppActivity />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/booking-changes"
          element={
            <RequirePermission permission="officeActivity.read">
              <BookingChanges />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/office-activity"
          element={
            <RequirePermission permission="officeActivity.read">
              <OfficeActivity />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/money-watch"
          element={
            <RequirePermission permission="moneyWatch.read">
              <MoneyWatch />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/app-updates"
          element={
            <RequirePermission permission="appUpdates.read">
              <AppUpdates />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/daily-brief"
          element={
            <RequirePermission permission="dailyBrief.read">
              <DailyBrief />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/lost-demand"
          element={
            <RequirePermission permission="lostDemand.read">
              <LostDemand />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/employee-dashboard/:employeeId"
          element={
            <RequirePermission permission="employeeDashboard.read">
              <EmployeeDashboard />
            </RequirePermission>
          }
        />

        <Route
          exact
          path="/admin/code-management"
          element={
            <RequirePermission permission="codeManagement.read">
              <CodeManagement />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/banners"
          element={
            <RequirePermission permission="banners.read">
              <Banners />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/home-builder"
          element={
            <RequirePermission permission="appHomeBuilder.read">
              <HomeBuilder />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/service-pages"
          element={
            <RequirePermission permission="appServicePages.read">
              <ServicePages />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/package-builder"
          element={
            <RequirePermission permission="packageBuilder.read">
              <PackageBuilders />
            </RequirePermission>
          }
        />
        <Route exact path="/admin/forbidden" element={<Forbidden />} />

        <Route
          exact
          path="/admin/category"
          element={
            <RequirePermission permission="category.read">
              <CategoryTable />
            </RequirePermission>
          }
        />

        <Route
          exact
          path="/admin/sub-category"
          element={
            <RequirePermission permission="subCategory.read">
              <SubCategoryTable />
            </RequirePermission>
          }
        />

        <Route
          exact
          path="/admin/prerequisite-checklist"
          element={
            <RequirePermission permission="services.read">
              <PrerequisiteChecklistTable />
            </RequirePermission>
          }
        />

        <Route
          exact
          path="/admin/create/sub-category"
          element={
            <RequirePermission permission="subCategory.create">
              <AddSubCategory />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/create/feedback-question"
          element={
            <RequirePermission permission="feedbackQuestions.create">
              <AddOrderFeedbackQuestion />
            </RequirePermission>
          }
        />

        <Route
          exact
          path="/admin/inventory-table"
          element={
            <RequirePermission permission="inventory.read">
              <InventoryTable />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/inventory-category-table"
          element={
            <RequirePermission permission="inventoryCategory.read">
              <InventoryCategoryTable />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/order-feedback-question-table"
          element={
            <RequirePermission permission="inventoryCategory.read">
              <OrderFeedbackQuestionTable />
            </RequirePermission>
          }
        />

        <Route
          exact
          path="/admin/inventory/create"
          element={
            <RequirePermission permission="inventory.create">
              <AddInventory />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/inventory-category/create"
          element={
            <RequirePermission permission="inventoryCategory.create">
              <AddInventoryCategory />
            </RequirePermission>
          }
        />

        <Route
          exact
          path="/admin/create/category"
          element={
            <RequirePermission permission="category.create">
              <AddCategory />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/staff-desk"
          element={
            <RequirePermission permission="dashboard.read">
              <StaffDesk />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/leave-management"
          element={
            <RequirePermission permission="dashboard.read">
              <LeaveManagement />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/campaigns"
          element={
            <RequirePermission permission="dashboard.read">
              <CampaignManagement />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/leads"
          element={
            <RequirePermission permission="dashboard.read">
              <LeadManagement />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/payouts"
          element={
            <RequirePermission permission="dashboard.read">
              <PayoutDashboard />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/rewards"
          element={
            <RequirePermission permission="rewards.read">
              <RewardsManagement />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/product-analytics"
          element={
            <RequirePermission permission="dashboard.read">
              <AdminProductAnalytics />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/cash-in-hand-report"
          element={
            <RequirePermission permission="dashboard.read">
              <CashInHandReport />
            </RequirePermission>
          }
        />
        <Route
          exact
          path="/admin/growth-reports"
          element={
            <RequirePermission permission="growthReports.read">
              <GrowthReports />
            </RequirePermission>
          }
        />
      </Routes>

      {!isDeepLinkRoute && <Footer />}
      {/* <TempNav /> */}
      {/* <GetApp /> */}
      {/* <Carrer /> */}
      {/* <ContactUs /> */}
    </div>
  );
}

export default App;
